export default "__VITE_ASSET__CEEOl4$A__"